<template>
    <div>
        <div class="p-1">
            <header class="text-center">
                <div class="header-icon header-icon--calendar"></div>
                <!-- <img src="img/egl/calendar-standard3.svg" alt="calendar icon" class="header-icon"> -->
                <h1 class="h2">{{ tBrandKey('our_service_times') }}</h1>
                <!-- <p>{{ $t('translations.we_try_to_respond_soon_during_these_hours')}}.</p> -->
            </header>

            <!-- <div class="container text-center">
                <div class="form-group">
                    <label>Select site</label>
                    <select v-model='site_id' class="form-control">
                        <option value=''>All Sites</option>
                        <option v-for='site in $root.provider.site' :key='site.id' :value='site.id'>{{site.name}}</option>
                    </select>
                </div>
            </div> -->

            <div v-if='$root.provider && $root.provider.availability_date' class="container service-times">
                <div class="row border-bottom pb-2 pt-2"><strong class="col-12">{{ $root.lookup.dayNames[1] | capitalise}}</strong> <span class="col-12">{{getAvailabilityFormatted($root.provider.availability_date, 1, 'Closed')}}</span></div>
                <div class="row border-bottom pb-2 pt-2"><strong class="col-12">{{ $root.lookup.dayNames[2] | capitalise}}</strong> <span class="col-12">{{getAvailabilityFormatted($root.provider.availability_date, 2, 'Closed')}}</span></div>
                <div class="row border-bottom pb-2 pt-2"><strong class="col-12">{{ $root.lookup.dayNames[3] | capitalise}}</strong> <span class="col-12">{{getAvailabilityFormatted($root.provider.availability_date, 3, 'Closed')}}</span></div>
                <div class="row border-bottom pb-2 pt-2"><strong class="col-12">{{ $root.lookup.dayNames[4] | capitalise}}</strong> <span class="col-12">{{getAvailabilityFormatted($root.provider.availability_date, 4, 'Closed')}}</span></div>
                <div class="row border-bottom pb-2 pt-2"><strong class="col-12">{{ $root.lookup.dayNames[5] | capitalise}}</strong> <span class="col-12">{{getAvailabilityFormatted($root.provider.availability_date, 5, 'Closed')}}</span></div>
            </div>



        </div>
        <footer class="container mt-2">
            <div @click="$router.go(-1)" class="btn btn-round btn-primary btn-block">{{ $t('translations.back')}}</div>
        </footer>
    </div>
</template>

<script>
export default {
    props: [
        'id'
    ],
    data: function(){
        return {
            calendar_dates: [],
            site_id: "",
            provider: {demand: [], availability_date: [], site: []},
        };
    },

    mounted() {
        for(var dayLoop = 0; dayLoop < 7 && this.calendar_dates.length < 5; dayLoop++) {
            var date = this.moment().add(dayLoop, 'days');
            var weekday = date.isoWeekday();
            if(weekday < 6) {
                this.calendar_dates.push(this.moment().add(dayLoop, 'days'));
            }
        }
    },

    methods: {

    }
}
</script>
